export const EVENTBRITE_LOGO =
    'https://cdn.evbuc.com/images/100912392/438776807040/1/original.20200513-210241';

export const CREATOR_NAME = {
    EVENTBRITE: 'Eventbrite',
};
